import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=2ae3a3b8&scoped=true"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmation.vue?vue&type=style&index=0&id=2ae3a3b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae3a3b8",
  null
  
)

export default component.exports